<template>
  <div :class="`articleViewBox layout_${data.neiRadio}`" :style="{
    'background': data.infoItme.bjColor,
    'padding': `${data.infoItme.sBj} ${data.infoItme.yeBj} ${data.infoItme.xBj}`
  }">
    <ul :class="`card${data.conValue}`">
      <li v-for="(item, index) in data.productList" :key="index" :style="{ 'border-radius': data.bianjiaoRadio === '直角' ? '0px' : '8px' }">
        <div class="imgs">
          <div :class="`scace${data.neiRadio === '3' ? '0' : scace}`">
            <img v-if="item.src" :src="item.src" alt="">
            <img v-else src="../../assets/image-upload.jpg" alt="">
        </div>
        </div>
        <div class="text" :style="{ 'text-align': data.duiqiRadio === '居左' ? 'left' : 'center' }">
          <h3 :style="{ 'font-weight': data.boldRadio === '有' ? 'bold' : 'normal' }">{{ item.name }}</h3>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>

export default {
  name: 'articleView',
  props: {
    data: Object
  },
  data () {
    return {
      scace: '1'
    }
  },
  watch: {
    'data.biliRadio': function (newVal) {
      if (this.data.biliRadio === '1:1') {
        this.scace = '1'
      } else if (this.data.biliRadio === '4:3') {
        this.scace = '2'
      } else if (this.data.biliRadio === '2:1') {
        this.scace = '4'
      } else {
        this.scace = '3'
      }
    }
  },
  methods: {},
  mounted () {
    console.log(this.data)
  }
}
</script>

<style scoped>
.articleViewBox {
  padding: 10px;
}

ul li {
  position: relative;
  overflow: hidden;
}

.layout_1 ul :nth-child(n + 2) {
  margin-top: 15px;
}

.layout_2 ul {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
}

.layout_2 ul li {
  margin: 0;
  width: calc(50% - 6px);
}

.layout_3 .imgs {
  float: left;
  width: 32%;
  border-bottom-left-radius: inherit;
  border-top-right-radius: 0;
}

.layout_3 .scace0 {
  padding: 0 0 100% 0;
}

.layout_3 .text {
  float: right;
  margin-left: 20px;
  width: calc(68% - 20px);
  padding: 20px 15px 10px 0;
}

.layout_3 li {
  margin-bottom: 15px;
}

.imgs {
  width: 100%;
  /* padding: 0 0 100% 0; */
  position: relative;
  border-radius: inherit;
}

.imgs img {
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  -o-object-fit: cover;
  object-fit: cover;
}

.layout_2 ul li:nth-child(n + 3) {
  margin-top: 15px;
}

ul li:before {
  content: "";
  display: block;
  width: 100%;
  height: 100%;
  z-index: 10;
  border: 1px solid transparent;
  background: none;
  position: absolute;
  left: 0;
  top: 0;
  box-sizing: border-box;
  border-radius: inherit;
}

h3 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.card1 li {
  background: #fff;
}

.card1 li:before {
  border-color: transparent;
}

.card2 li {
  background: #fff;
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.1);
}

.card2 li:before {
  border-color: transparent;
}

.card3 li {
  overflow: hidden;
  /* margin: 0;
  width: calc(50% - 6px); */
}

.card3 li:before {
  border: 1px solid #e8e8e8;
}

.card4 li {
  background: none;
}

.card4 li:before {
  border: 1px solid transparent;
}

.articleViewBox .scace1 {
  padding: 0 0 100% 0;
}

.articleViewBox .scace2 {
  padding: 0 0 75% 0;
}

.articleViewBox .scace3 {
  padding: 0 0 66.66% 0;
}

.articleViewBox .scace4 {
  padding: 0 0 50% 0;
}
</style>



// WEBPACK FOOTER //
// src/components/article/articleView.vue